module.exports = __webpack_public_path__ + "img/bulk-import.6056ff20.png";